/**
 * Detect an issuer's brand palette from a card name.
 * Returns a gradient string + accent color + short brand label.
 * All heuristic — designed to give a distinct look without needing real BIN data.
 */

const PALETTES = {
  visa: {
    label: "Visa",
    gradient: "linear-gradient(135deg, #1A1F71 0%, #0B1348 60%, #05082B 100%)",
    accent: "#F7B600",
  },
  mastercard: {
    label: "Mastercard",
    gradient: "linear-gradient(135deg, #EB001B 0%, #F79E1B 100%)",
    accent: "#111111",
  },
  amex: {
    label: "Amex",
    gradient: "linear-gradient(135deg, #006FCF 0%, #0A2C5C 60%, #061B3A 100%)",
    accent: "#B7D5F0",
  },
  discover: {
    label: "Discover",
    gradient: "linear-gradient(135deg, #FF6000 0%, #C24500 100%)",
    accent: "#FFF6E0",
  },
  chase: {
    label: "Chase",
    gradient: "linear-gradient(135deg, #117ACA 0%, #0A4E82 60%, #052840 100%)",
    accent: "#F5F7FB",
  },
  barclays: {
    label: "Barclays",
    gradient: "linear-gradient(135deg, #00AEEF 0%, #0072A3 100%)",
    accent: "#E6F7FF",
  },
  capitalone: {
    label: "Capital One",
    gradient: "linear-gradient(135deg, #C8102E 0%, #6E0A1E 100%)",
    accent: "#F5F7FB",
  },
  citi: {
    label: "Citi",
    gradient: "linear-gradient(135deg, #056DAE 0%, #033651 100%)",
    accent: "#E4F1FA",
  },
  hsbc: {
    label: "HSBC",
    gradient: "linear-gradient(135deg, #DB0011 0%, #7A0006 100%)",
    accent: "#FFFFFF",
  },
  monzo: {
    label: "Monzo",
    gradient: "linear-gradient(135deg, #FF3464 0%, #B3244A 100%)",
    accent: "#111111",
  },
  revolut: {
    label: "Revolut",
    gradient: "linear-gradient(135deg, #0666EB 0%, #062A66 100%)",
    accent: "#F5F7FB",
  },
  wells: {
    label: "Wells Fargo",
    gradient: "linear-gradient(135deg, #D71E28 0%, #7A1017 100%)",
    accent: "#FFCC00",
  },
  natwest: {
    label: "NatWest",
    gradient: "linear-gradient(135deg, #42145F 0%, #1D0A2C 100%)",
    accent: "#00A0DC",
  },
  santander: {
    label: "Santander",
    gradient: "linear-gradient(135deg, #EC0000 0%, #9C0000 100%)",
    accent: "#FFFFFF",
  },
  default: {
    label: "Card",
    gradient: "linear-gradient(135deg, #1E3A8A 0%, #0F1E4A 55%, #060B19 100%)",
    accent: "#00E676",
  },
};

const KEYWORDS = [
  { rx: /amex|american\s*express/i, key: "amex" },
  { rx: /master\s*card|mastercard/i, key: "mastercard" },
  { rx: /discover/i, key: "discover" },
  { rx: /chase/i, key: "chase" },
  { rx: /barclay/i, key: "barclays" },
  { rx: /capital\s*one/i, key: "capitalone" },
  { rx: /citi/i, key: "citi" },
  { rx: /hsbc/i, key: "hsbc" },
  { rx: /monzo/i, key: "monzo" },
  { rx: /revolut/i, key: "revolut" },
  { rx: /wells\s*fargo/i, key: "wells" },
  { rx: /natwest/i, key: "natwest" },
  { rx: /santander/i, key: "santander" },
  { rx: /visa/i, key: "visa" },
];

export function detectIssuer(cardName = "", providerName = "") {
  const haystack = `${cardName} ${providerName || ""}`.trim();
  for (const { rx, key } of KEYWORDS) {
    if (rx.test(haystack)) return { key, ...PALETTES[key] };
  }
  return { key: "default", ...PALETTES.default };
}

export default detectIssuer;
